






import { Vue, Component } from 'vue-property-decorator';

@Component({
    components: {
    }
})
export default class AppComponent extends Vue {

    created() {}

    login() {}

}
